module.exports = __webpack_public_path__ + "officialStatic/img/pse3.e7b21c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/pse3.png
// module id = fufP
// module chunks = 0